import InvoiceGenerate from './InvoiceGenerate';

export default InvoiceGenerate;
